import { AuthTokenInfo } from "../models/AuthTokenInfo";
import { CommonUtil } from "./CommonUtil";
import {jwtDecode} from 'jwt-decode';

export interface TokenClaims {
    Admin?: string;
    UserName: string;
    Email: string;
}

export class TokenUtil {
    private static accessKey = "accessKey";
    private static refreshKey = "refreshKey";

    
    get isAutheticated(): boolean {
        var token = this.accessToken;
        return (token != null && token != "");
    }

    get accessToken(): string {
        var token = window.localStorage.getItem(TokenUtil.accessKey) ?? "";
        return token;
    }

    get refreshToken(): string {
        var token = window.localStorage.getItem(TokenUtil.refreshKey) ?? "";
        return token;
    }

    public getActiveUserId(): string {
        var token = this.accessToken;
        if(CommonUtil.isNullOrEmpty(token))
          return null;
  
        var decoded = jwtDecode(token);
        return decoded?.sub;
      }

     getClaims(): TokenClaims {
        var token = this.accessToken;
        if(CommonUtil.isNullOrEmpty(token))
            return null;

        return jwtDecode<TokenClaims>(token);
    }

    getAuthInfo(): AuthTokenInfo{
        var info = new AuthTokenInfo();
        info.accessToken = this.accessToken;
        info.refreshToken = this.refreshToken;
        return info;
    }


    setAuthInfo(info: AuthTokenInfo){
        if(info)
        {
            window.localStorage.setItem(TokenUtil.accessKey, info.accessToken);
            window.localStorage.setItem(TokenUtil.refreshKey, info.refreshToken);
        }
        else
        {
            window.localStorage.removeItem(TokenUtil.accessKey);
            window.localStorage.removeItem(TokenUtil.refreshKey);
        }
    }


    getAuthHeader(): string{
        var token = this.accessToken;
        // console.log("auth header", token);
        var authHeader = token ? `Bearer ${token}` : "";
        return authHeader;
    }
    
}